export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "detailed_report": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reporte detallado"])},
          "from_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desde"])},
          "to_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hasta"])},
          "crop_field_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productor"])},
          "tech_visit_form_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulario de visita técnica"])},
          "download_report": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar reporte"])}
        }
      }
    }
  })
}